var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.699 18.167H6.69l-3.144-2.092-2.584-1.568c.113 2.038 1.745 3.66 3.736 3.66z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.895 16.971l-2.25-.597H4.699c-1.111 0-2.015-.939-2.015-2.092v-1.147l-.864-.962-.863.158v1.95c0 .076.002.151.006.226l5.728 3.66H13.5l-1.604-1.196z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.358 15.734c-.366.394-.88.64-1.448.64H9.645l3.854 1.793h.411c1.344 0 2.524-.74 3.184-1.846l-.881-.545-.855-.042z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.925 11.87v2.412c0 .563-.216 1.075-.567 1.452l1.736.587a3.972 3.972 0 0 0 .558-2.04v-2.126l-.893-.52-.834.235z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.652 5.884l-.92-.227-.807.502v5.711l1.727.285z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.652 4.718c0-1.95-1.392-3.57-3.2-3.844l-2.264.978-1.147.774h2.869c1.111 0 2.015.939 2.015 2.092v1.44l1.727-.274V4.718z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.317.833l-2.141.834-1.69.96h3.555L14.452.873c-.18-.027-.36-.04-.542-.04h-2.593zM9.304 14.58a4.71 4.71 0 0 0 1.703-.317L8.202 12.94l-2.973-.632c.878 1.368 2.377 2.271 4.075 2.271z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.69 11.17c-.518.795-1.394 1.318-2.386 1.318-1.313 0-2.423-.918-2.767-2.168l-.772-.5-1.332.153c.074.835.348 1.638.796 2.336l5.778 1.954c1.25-.483 2.258-1.481 2.787-2.745l-1.035-.544-1.07.197z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.426 9.5c0-.74.261-1.419.693-1.941L5.89 7.38l-1.248.572a5.238 5.238 0 0 0-.21 2.02l2.104.348a3.084 3.084 0 0 1-.111-.82zm7.772 0a5.186 5.186 0 0 0-.895-2.925l-1.219-.18-1.253.573A3.016 3.016 0 0 1 12.183 9.5c0 .618-.182 1.194-.493 1.67l2.104.348a5.216 5.216 0 0 0 .404-2.018z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.304 6.511c.561 0 1.084.168 1.527.457l2.472-.393c-.886-1.303-2.348-2.155-3.999-2.155-2.178 0-4.029 1.485-4.66 3.532l2.475-.394a2.83 2.83 0 0 1 2.185-1.047zm4.606-.597c.635 0 1.151-.536 1.151-1.196 0-.659-.516-1.195-1.151-1.195s-1.151.536-1.151 1.195c0 .66.516 1.196 1.151 1.196zM2.684 11.449l-.832-.43-.895-.154v1.466l1.727.804z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.957 9.399v1.466l1.727.584V9.684l-.898-.335z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.684 8.264l-.888-.009-.84.283v.86l1.728.286z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.684 6.919l-.915.096-.812.791v.732l1.727-.274z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.957 7.806l1.727-.887V4.874l-1.013.1-.714.709z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.643.833l-3.94 1.574-2.701 1.708c-.03.2-.045.401-.045.603v.965l1.727-.809v-.156c0-1.153.904-2.092 2.015-2.092h2.787L11.317.833H7.643z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.699.833c-1.866 0-3.417 1.425-3.697 3.282L7.643.833H4.7z"
  }))));
};
export default SvgInstagram;